export interface DataTableColumn {
    // å­æ®µå
    title?: string;
    // å­æ®µid
    field?: string;
    // åå®½
    width: number;
    // å¯¹é½æ¹å¼
    hAlign?: string;
    // åæ¨ªåå¯¹é½æ¹å¼
    align?: string;
    // åçæ¾é
    hidden?: boolean;
    // åºå®å
    fixed?: any;
    // åæåº
    sortable?: boolean;
    // ç­é
    multipleFilter: boolean;
    filter?: any;
    filterMethod?: (value: any, row: any) => boolean;
    className?: string;
    // å¯ç¼è¾
    edit?: string;
    // ååºå¼å±æ§
    media?: object;
    // åæ ¼å¼åAPI ç¨æ·èªå®ä¹
    formatter?: any;
}
export const convertColumns = (columns: any, direction: any) => {
    const tempFixedColumns = [];
    const tempNotFixedColumns = [];
    columns.forEach(ele => {
        if (ele.fixed && (ele.fixed === direction || ele.fixed.type === direction)) {
            tempFixedColumns.push(ele);
        } else {
            tempNotFixedColumns.push(ele);
        }
    });
    return tempFixedColumns.concat(tempNotFixedColumns);
};
function typeOf(obj) {
    const toString = Object.prototype.toString;
    const map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object'
    };
    return map[toString.call(obj)];
}
export const deepCopy = (data) => {
    const t = typeOf(data);
    let o;

    if (t === 'array') {
        o = [];
    } else if (t === 'object') {
        o = {};
    } else {
        return data;
    }

    if (t === 'array') {
        for (const dataItem of data) {
            o.push(deepCopy(dataItem));
        }
    } else if (t === 'object') {
        for (const i of Object.keys(data)) {
            o[i] = deepCopy(data[i]);
        }
    }
    return o;
};



